import axios from "axios";
import { useAuthStore } from "@/store/authStore";

const api = axios.create({
  // .trim() guards against a stray newline/space baked into the Vercel env var
  // (a trailing "\n" once turned every request into ".../api\n/..." → 9× auth loop → crash)
  baseURL: (import.meta.env.VITE_API_URL || "https://backend-production-dfe8.up.railway.app/api").trim(),
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

// Attach JWT on every request
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// NOTE: We deliberately do NOT auto-logout here on a 401. A single stray 401 from
// any one screen used to call logout() → which flipped isAuthenticated → which made
// the app bounce back to Core in an infinite loop that hammered the backend.
// Session validity is owned by the boot gate (authStore.verifySession): it verifies
// once against /auth/me and only clears the session on an explicit 401/403 there.
api.interceptors.response.use(
  (res) => res,
  (err) => Promise.reject(err)
);

export default api;
